/* eslint-disable @typescript-eslint/no-explicit-any */
export default (function (funcOrValue) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  return typeof funcOrValue === 'function' ? funcOrValue(...args) : funcOrValue;
});
//# sourceMappingURL=callOrReturn.js.map